// Enumeración para nombrar los estados del proceso de sincronización
// cuando trabajamos con modo offline / online

export const syncProcessStatuses = {
  'CLEAN': 0, // No hay registros para sincronizar
  'WAITING_FOR_SYNC': 1, // Hay registros para sincronizar, esperando conexión
  'IN_PROGRESS': 2, // Proceso de sincronización en progreso
  'ERROR': 3 // Error durante el proceso de sincronización
}